export default function assetUrl(asset) {
  if (typeof asset === 'string') return asset;
  return asset && typeof asset.default === 'string' ? asset.default : '';
}
